﻿import React from "react";

class PressImagesForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.handleSearch();
    }
    
    render() {
        return (
            <div className={"onerow"}>
                <div className={"col12 last"} style={{ marginBottom: "10px" }}>
                    {/*<h2>{i18njs["Resource.pressimages"]}</h2>*/}
                    <form onSubmit={this.handleSubmit} id="pressImageSearchForm">
                        <label htmlFor={"txtPressImageProductName"} style={{ display: "block" }}>{i18njs["Resource.enterproductname"]}</label>
                        <div className="inlineInputWrapper">
                            <input type={"text"} id={"txtPressImageProductName"} onChange={this.props.handleSearchTermChange} className={"txtPressImageProductNameTextBox"} value={this.props.searchTerm} />
                            <button className={"btn"} type={"submit"}>Search</button>
                        </div> 
                    </form>
                </div>
            </div>
        );
    }
}

export default PressImagesForm;